var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{class:[_vm.$style.textarea, _vm.$style[_vm.type], { [_vm.$style.textarea_error]: _vm.error }],attrs:{"maxlength":_vm.maxlength,"readonly":_vm.readonly,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }